module.exports = __webpack_public_path__ + "static/media/reservation.d363cb78.svg";